import { render, staticRenderFns } from "./MarcasABM.vue?vue&type=template&id=79ebfb48&"
import script from "./MarcasABM.vue?vue&type=script&lang=js&"
export * from "./MarcasABM.vue?vue&type=script&lang=js&"
import style0 from "./MarcasABM.vue?vue&type=style&index=0&id=79ebfb48&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports